import { DiffCycleMonthToYearUpgradeExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/diffCycle-monthToYear-upgrade';
import { SameCycleMonthToMonthDowngradeExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/sameCycle-monthToMonth-downgrade';
import { SameCycleUpgradeExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/sameCycle-upgrade';
import { PreviewInvoiceType } from "../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/enums/PreviewInvoiceType";
// import { SameCyclePartnerUpgradeExpected } from '../../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/sameCycle-partner-upgrade';
import { DiffCycleMonthToYearDowngradeExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/diffCycle-monthToYear-downgrade';
import { DiffCycleYearToMonthDowngradeExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/diffCycle-yearToMonth-downgrade';
import { DiffCycleYearToMonthUpgradeExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/diffCycle-yearToMonth-upgrade';
import { NewSubscriptionExpected } from '../../../components/Modal/SubscribeSwitchPlan/components/OrderSummaryV2/dummyData/newSubscription';
import Big from 'big.js';

export function getDummyPreviewInvoice(
    { request, previewType, dummyMetaData }) {
    const {
        // isDummy,
        billingCycleBefore, billingCycleAfter,
        subtotalBefore, subtotalAfter,
        overrideInvoiceNow, overrideInvoiceNext,
        dummyData,
    } = dummyMetaData || {};

    let invoiceNow, invoiceNext;

    switch (previewType) {
        case PreviewInvoiceType.SUBSCRIBE_DURING_TRIAL:
            invoiceNow = undefined;
            invoiceNext = NewSubscriptionExpected.invoice_preview;
            invoiceNext.first_billing_date = request.start_date;
            break;
        case PreviewInvoiceType.SUBSCRIBE_AFTER_TRIAL:
            invoiceNow = NewSubscriptionExpected.invoice_preview;
            invoiceNow.first_billing_date = request.start_date;
            invoiceNext = undefined;
            break;
        case PreviewInvoiceType.SWITCH_SAME_CYCLE_UPGRADE:
        case PreviewInvoiceType.SWITCH_SAME_CYCLE_SAME:
            invoiceNow = SameCycleUpgradeExpected.today;
            invoiceNext = SameCycleUpgradeExpected.next;
            break;
        case PreviewInvoiceType.SWITCH_DIFF_BILLING_CYCLE_TO_FREE_PLAN: // added by marcus for ENG-3635
        case PreviewInvoiceType.SWITCH_DIFF_BILLING_CYCLE: {
            if (billingCycleBefore === 1 && billingCycleAfter === 12) {
                if (Big(subtotalBefore || 0).lt(Big(subtotalAfter).div(Big(12)))) {
                    invoiceNow = DiffCycleMonthToYearUpgradeExpected.today;
                    invoiceNext = DiffCycleMonthToYearUpgradeExpected.next;
                }
                else {
                    invoiceNow = DiffCycleMonthToYearDowngradeExpected.today;
                    invoiceNext = DiffCycleMonthToYearDowngradeExpected.next;
                }
            }
            else if (billingCycleBefore === 12 && billingCycleAfter === 1) {
                if ((Big(subtotalBefore).div(Big(12))).lt(Big(subtotalAfter || 0))) {
                    invoiceNow = DiffCycleYearToMonthUpgradeExpected.today;
                    invoiceNext = DiffCycleYearToMonthUpgradeExpected.next;
                }
                else {
                    invoiceNow = DiffCycleYearToMonthDowngradeExpected.today;
                    invoiceNext = DiffCycleYearToMonthDowngradeExpected.next;
                }
            }
            break;
        }
        case PreviewInvoiceType.SWITCH_SAME_CYCLE_DOWNGRADE:
            invoiceNow = undefined;
            invoiceNext = SameCycleMonthToMonthDowngradeExpected.next;

            if (dummyData)
                invoiceNext = dummyData.next;
            break;
        default:
            invoiceNow = overrideInvoiceNow || invoiceNow;
            invoiceNext = overrideInvoiceNext || invoiceNext;
            break;
    }
    invoiceNow = overrideInvoiceNow || invoiceNow;
    invoiceNext = overrideInvoiceNext || invoiceNext;

    return { invoiceNow, invoiceNext };
}
